"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getMoleculeWithH = void 0;
const ensureHeterotopicChiralBonds_js_1 = require("../diastereotopic/ensureHeterotopicChiralBonds.js");
const MAX_NB_ATOMS = 250;
/**
 * Expand all the implicit hydrogens and ensure that the heterotopic bonds
 * @param molecule
 * @returns
 */
function getMoleculeWithH(molecule) {
    const moleculeWithH = molecule.getCompactCopy();
    moleculeWithH.addImplicitHydrogens();
    if (moleculeWithH.getAllAtoms() > MAX_NB_ATOMS) {
        throw new Error(`too many atoms to add hydrogens: ${moleculeWithH.getAllAtoms()} > ${MAX_NB_ATOMS}`);
    }
    (0, ensureHeterotopicChiralBonds_js_1.ensureHeterotopicChiralBonds)(moleculeWithH);
    return moleculeWithH;
}
exports.getMoleculeWithH = getMoleculeWithH;
//# sourceMappingURL=getMoleculeWithH.js.map